import { privateClient } from "@/api/privateClient";
import { INSTITUTION_ADMIN_ENDPOINTS } from "../../../institutionAdmin.endpoints";
import type { HostelBuilding, HostelRoom, HostelAllocation } from "../types";

const HOSTEL = INSTITUTION_ADMIN_ENDPOINTS.FACILITIES.HOSTEL;

export async function fetchBuildings(institutionId: number): Promise<HostelBuilding[]> {
  const { data } = await privateClient.get(HOSTEL.BUILDINGS(institutionId));
  return data.buildings ?? [];
}

export async function createBuilding(institutionId: number, payload: { name: string }): Promise<HostelBuilding> {
  const { data } = await privateClient.post(HOSTEL.BUILDINGS(institutionId), payload);
  return data.building;
}

export async function fetchRooms(institutionId: number, buildingId?: number): Promise<HostelRoom[]> {
  const { data } = await privateClient.get(HOSTEL.ROOMS(institutionId), { params: { buildingId } });
  return data.rooms ?? [];
}

export async function createRoom(
  institutionId: number,
  payload: { buildingId: number; roomNumber: string; capacity?: number }
): Promise<HostelRoom> {
  const { data } = await privateClient.post(HOSTEL.ROOMS(institutionId), payload);
  return data.room;
}

export async function allocate(
  institutionId: number,
  payload: { roomId: number; studentId: number; academicYearId?: number }
): Promise<HostelAllocation> {
  const { data } = await privateClient.post(HOSTEL.ALLOCATE(institutionId), payload);
  return data.allocation;
}

export async function vacate(institutionId: number, allocationId: number): Promise<HostelAllocation> {
  const { data } = await privateClient.post(HOSTEL.VACATE(institutionId, allocationId));
  return data.allocation;
}

export async function fetchStudentAllocations(
  institutionId: number,
  studentId: number,
  academicYearId?: number
): Promise<HostelAllocation[]> {
  const { data } = await privateClient.get(HOSTEL.STUDENT_ALLOCATION(institutionId, studentId), { params: { academicYearId } });
  return data.allocations ?? [];
}
